import { useEffect } from "react";

export const useIntersection = (selector) => {
  useEffect(() => {
    let lastScrollY = window.scrollY;

    const observer = new IntersectionObserver(
      (entries) => {
        const currentScrollY = window.scrollY;
        const isScrollingDown = currentScrollY > lastScrollY;

        entries.forEach((entry) => {
          // Mostrar al cargar si ya está en pantalla
          if (entry.isIntersecting && lastScrollY === 0) {
            entry.target.classList.add("visible");
          }

          // Mostrar solo si hago scroll hacia abajo
          if (entry.isIntersecting && isScrollingDown) {
            entry.target.classList.add("visible");
          }
        });

        lastScrollY = currentScrollY;
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(selector);
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [selector]);
};
